// Forecast API
import {
    ForecastFilterRequestResponse, ForecastObjectResponse,
} from 'app/requests/Forecast/Forecast.types'
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    WithId,
} from 'app/types/common.types'

type ForecastRequests = {
    filterRequest: RequestConfigFunction<
        { params?: Record<string, any> },
        ForecastFilterRequestResponse
    >,
    get: RequestConfigFunction<WithId<number>, ForecastObjectResponse>,
    create: RequestConfigFunction<Record<string, any>>,
}

const forecastRequests: ForecastRequests = {
    filterRequest: ({
        params = {},
    } = {}) => {
        return {
            url: 'forecast/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `forecast/${id}`,
            method: 'GET',
        }
    },
    create: (data) => {
        return {
            url: 'forecast',
            method: 'POST',
            data,
        }
    },
}

export default forecastRequests
